/**
 * The CooeyNet mark: an upward triangle split into three red pieces (apex + two
 * lower) by a Y-shaped negative space -- the stem drops to the base midpoint and
 * two arms rise to the side-edge midpoints. Authored in a 24x24 viewBox so every
 * Logo surface can share one definition.
 *
 * The raster favicons use the same geometry; see scripts/gen-cooey-favicons.js.
 */
export const COOEY_MARK_VIEWBOX = '0 0 24 24'

export const COOEY_MARK_PATH =
  'M12 2.4 L7.41 10.83 L12 12.45 L16.59 10.83 Z ' +
  'M2.2 20.4 L11.35 20.4 L11.06 14.26 L6.79 11.97 Z ' +
  'M21.8 20.4 L17.21 11.97 L12.94 14.26 L12.65 20.4 Z'
